import type { WeaponDef } from '../../sim/defs';
import { Stat } from '../../sim/stats';

/** A06 — ÉVENTAIL. « Tir en éventail large »
 *  (nœud `arme-eventail`, ouvert par « 200 frôlements dans une run »).
 *
 *  10 volées/s × 2 projectiles × 10 dégâts = 200 DPS — le MÊME nombre que le
 *  VULCAN, au chiffre près. Le DPS nominal ne bouge pas d'un iota.
 *
 *  ── Un ANGLE au tir primaire, pas une nouvelle forme d'émission ────────────
 *  Le tir primaire part tout droit depuis toujours. L'Éventail ajoute une seule
 *  chose : une ouverture ANGULAIRE (`bulletSpread`, en degrés), lue par
 *  `playerSystem`, qui donne un `vx` aux deux canons de fuselage — l'un à −15°,
 *  l'autre à +15°. Aucune balle persistante, aucune conduite : c'est du
 *  BALISTIQUE mono-contact, tiré en V. Rien à borner côté multi-cible : chaque
 *  balle meurt sur sa première cible comme n'importe quel tir droit.
 *
 *  ── Un sidegrade FRANC, et c'est tout l'intérêt ───────────────────────────
 *  L'éventail est un couteau à double tranchant, sans malus de statistique parce
 *  que la GÉOMÉTRIE est le malus :
 *    · BON contre les groupes DISPERSÉS et les ennemis qui traversent à hauteur
 *      du vaisseau — les deux rounds couvrent une largeur qui s'ouvre avec la
 *      distance (± ~215 u à 400 u de portée).
 *    · MAUVAIS sur une cible unique LOINTAINE — les deux rounds la manquent par
 *      les côtés, là où le VULCAN aurait planté sa colonne. Sur une cible proche,
 *      les deux touchent encore.
 *  L'axe peuplé est « couverture large / imprécis à distance », distinct des
 *  autres armes. Le levier reste la FORME du tir, jamais la puissance. */
const eventail: WeaponDef = {
  id: 'eventail',
  name: 'Éventail',
  modifiers: [
    // 30° d'ouverture totale (±15° par canon). Catégoriel : posé en `add` depuis
    // zéro, comme `bulletMode`, et absent de `dps()` — le nominal reste 200.
    { stat: Stat.BulletSpread, op: 'add', value: 30 },
  ],
  text: '10 volées/s × 2 × 10 dégâts — 200 DPS, tir en ÉVENTAIL large (±15°)',
};

export default eventail;
